import { StatusChipText } from '@labrav/react-components'

import { ProductStatus } from '../../modules/productsListing/types'

export const getStatusAndLabelForProduct = (status: ProductStatus) => {
  switch (status) {
    case ProductStatus.PRODUCT_STATUS_CREATION_FAILED:
      return {
        textColor: StatusChipText.RED,
        label: 'Failed',
      }
    case ProductStatus.PRODUCT_STATUS_DRAFT:
      return {
        textColor: StatusChipText.GRAY,
        label: 'Draft',
      }
    case ProductStatus.PRODUCT_STATUS_LIMITED:
      return {
        textColor: StatusChipText.LIGHTBLUE,
        label: 'Limited',
      }
    case ProductStatus.PRODUCT_STATUS_PUBLIC:
      return {
        textColor: StatusChipText.GREEN,
        label: 'Public',
      }
    case ProductStatus.PRODUCT_STATUS_IN_PROGRESS:
      return {
        textColor: StatusChipText.LIGHTBLUE,
        label: 'In Progress',
      }
    case ProductStatus.PRODUCT_STATUS_AWS_TESTING:
      return {
        textColor: StatusChipText.LIGHTBLUE,
        label: 'AWS testing',
      }
    case ProductStatus.PRODUCT_STATUS_RESTRICTED:
      return {
        textColor: StatusChipText.RED,
        label: 'Restricted',
      }
    case ProductStatus.PRODUCT_STATUS_LABRA_TESTING:
      return {
        textColor: StatusChipText.LIGHTBLUE,
        label: 'Labra testing',
      }
    case ProductStatus.PRODUCT_STATUS_REJECTED:
      return {
        textColor: StatusChipText.RED,
        label: 'Rejected',
      }
    case ProductStatus.PRODUCT_STATUS_MIGRATION_IN_QUEUE:
      return {
        textColor: StatusChipText.LIGHTBLUE,
        label: 'Migration in queue',
      }
    case ProductStatus.MIGRATION_FAILED:
      return {
        textColor: StatusChipText.RED,
        label: 'Migration failed',
      }
    case ProductStatus.MIGRATION_IN_PROGRESS:
      return {
        textColor: '#BA8E23',
        label: 'Migration in progress',
      }
    default:
      return {
        textColor: StatusChipText.LIGHTBLUE,
        label: 'Limited',
      }
  }
}
